import request from '@/utils/request'

export function login(loginInfo) {
  return request({
    url: '/memberLogin/login',
    method: 'post',
    params: loginInfo
  })
}
export function logout(token) {
  return request({
    url: '/user/logout',
    method: 'post',
    params: { access_token: token },
  })
}
export function getInfo(token) {
  return request({
    url: '/memberLogin/info',
    method: 'get',
    params: {access_token: token }
  })
}
export function sendSMS(phone) {
  return request({
    url: '/memberLogin/sendSMS',
    method: 'post',
    params: { phone : phone }
  })
}
export function registerMember(param) {
  return request({
    url: '/memberLogin/register',
    method: 'post',
    params: param
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js